import { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import {
  doc as firestoreDoc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { showErrorToast } from "../toastmsg";

export const useAuthUser = () => {
  const [userRole, setUserRole] = useState<string | null>(null);
  const [currentUserUid, setCurrentUserUid] = useState<string | null>(null);
  const [userBranch, setUserBranch] = useState<string | null>(null);
  const [currentUserDisplayName, setCurrentUserDisplayName] = useState<
    string | null
  >(null);
  const [branchUserIds, setBranchUserIds] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUserUid(user.uid);

        try {
          const userDoc = await getDoc(firestoreDoc(db, "users", user.uid));
          if (userDoc.exists() && isMounted) {
            const userData = userDoc.data();
            setUserRole(userData.role);
            setUserBranch(userData.branch || null);
            setCurrentUserDisplayName(userData.displayName || "");
            if (userData.role === "Branch Manager") {
              const branch = userData.branch;
              if (branch) {
                const q = query(
                  collection(db, "users"),
                  where("branch", "==", branch),
                  where("role", "in", ["sales", "part-time sales"]),
                );
                const branchUsersSnap = await getDocs(q);
                const salesUserIds = branchUsersSnap.docs.map((d) => d.id);

                if (!salesUserIds.includes(user.uid)) {
                  salesUserIds.push(user.uid);
                }
                setBranchUserIds(salesUserIds);
              }
            }
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          if (isMounted) {
            showErrorToast("Failed to load user information");
          }
        } finally {
          if (isMounted) setIsLoading(false);
        }
      } else {
        if (isMounted) {
          setCurrentUserUid(null);
          setUserRole(null);
          setCurrentUserDisplayName(null);
          setBranchUserIds([]);
          setIsLoading(false);
        }
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, []);

  return {
    userRole,
    userBranch,
    currentUserUid,
    currentUserDisplayName,
    branchUserIds,
    isLoading,
  };
};
